module.exports = __webpack_public_path__ + "static/media/message.6d3efc0d.svg";